(function () {
  'use strict';
  var ROOT_ID = 'nzs-jmrev';
  var SRC_RE = /\s*Verified purchase review, originally published on\s+(.+?)\.?\s*$/i;

  function extractSourceBadges(root) {
    var revs = root.querySelectorAll('.jdgm-rev');
    for (var i = 0; i < revs.length; i++) {
      var rev = revs[i];
      if (rev.dataset.nzsSrcDone === '1') continue;
      rev.dataset.nzsSrcDone = '1';
      var body = rev.querySelector('.jdgm-rev__body');
      if (!body) continue;
      // credit line lives in the LAST text-bearing element of the body
      var els = body.querySelectorAll('p, div, span');
      var target = els.length ? els[els.length - 1] : body;
      var m = SRC_RE.exec(target.textContent || '');
      if (!m) { m = SRC_RE.exec(body.textContent || ''); target = m ? body : null; }
      if (!m || !target) continue; // native NZS review -> no badge
      var label = m[1].replace(/\s*\([^)]*\)\s*$/, '').trim(); // "Ghost (ghostlifestyle.com)" -> "Ghost"
      if (!label) continue;
      target.textContent = (target.textContent || '').replace(SRC_RE, '').replace(/\s+$/, '');
      if (!target.textContent.trim() && target !== body) target.remove();
      var w = document.createElement('span');
      w.className = 'nzs-jm-srcwrap';
      var lb = document.createElement('span');
      lb.className = 'nzs-jm-srclabel';
      lb.textContent = 'Sourced from:';
      var b = document.createElement('span');
      b.className = 'nzs-jm-src';
      b.title = 'Review originally published on ' + m[1];
      b.textContent = label;
      w.appendChild(lb);
      w.appendChild(b);
      rev.appendChild(w);
    }
  }

  function init() {
    var root = document.getElementById(ROOT_ID);
    if (!root || root.dataset.nzsJmInit === '1') return;
    root.dataset.nzsJmInit = '1';

    var tpl = root.querySelector('template[data-nzs-jm-skel]');

    // NZS API mode: this shop is on Judge.me's "review widget revamp" backend, so
    // reviews_for_widget returns JSON data (no pre-rendered html) and the legacy
    // jdgm.js paginate/filter never arms. We render cards + pager + star filter
    // ourselves from the JSON; the SSR metafield page stays for SEO.
    var PER_PAGE = 12;
    var API = 'https://cdn.judge.me/reviews/reviews_for_widget';
    var state = { page: 1, filter: null, totalPages: 0, busy: false };

    function listEl() { return root.querySelector('.jdgm-rev-widg__reviews'); }
    function widgEl() { return root.querySelector('.jdgm-rev-widg'); }

    function skeletons(listEl, n) {
      var frag = document.createDocumentFragment();
      for (var i = 0; i < n; i++) frag.appendChild(tpl.content.cloneNode(true));
      var wrap = document.createElement('div');
      wrap.dataset.nzsJmSkels = '1';
      wrap.style.display = 'contents';
      wrap.appendChild(frag);
      listEl.appendChild(wrap);
      listEl.classList.add('nzs-jm-loading');
    }
    function clearSkeletons(listEl) {
      var w = listEl.querySelector('[data-nzs-jm-skels]');
      if (w) w.remove();
      listEl.classList.remove('nzs-jm-loading');
    }

    function shopParams() {
      try { if (window.jdgm && jdgm.shopParams) return jdgm.shopParams(); } catch (e) {}
      var sd = (window.Shopify && window.Shopify.shop) || '';
      return { url: sd, shop_domain: sd, platform: 'shopify' };
    }

    function starsHtml(n) {
      var h = '';
      for (var i = 1; i <= 5; i++) h += '<span class="jdgm-star jdgm--' + (i <= n ? 'on' : 'off') + '"></span>';
      return h;
    }
    function fmtDate(iso) {
      var d = new Date(iso);
      if (isNaN(d)) return '';
      var p = function (x) { return (x < 10 ? '0' : '') + x; };
      return p(d.getDate()) + '/' + p(d.getMonth() + 1) + '/' + d.getFullYear();
    }

    function extractSubs(el) {
      // NZS-RVF-0905: the popup appends "Flavour 5/5 · Effectiveness 4/5 · Value 5/5" as the last line; show it as mini star rows
      var body = el.querySelector('.jdgm-rev__body'), found = '';
      if (!body) return;
      body.innerHTML = body.innerHTML.replace(/(?:<br\s*\/?>\s*|<p>\s*)?((?:Flavour|Effectiveness|Value) [1-5]\/5(?:\s*(?:\u00b7|&middot;|&#183;)\s*(?:Flavour|Effectiveness|Value) [1-5]\/5){0,2})\s*(?:<\/p>)?\s*$/i, function (_, line) { found = line; return ''; });
      if (!found) return;
      var wrap = document.createElement('div'); wrap.className = 'nzs-jm-subs';
      found.replace(/(Flavour|Effectiveness|Value) ([1-5])\/5/gi, function (_, k, n) {
        var s = document.createElement('span'); s.innerHTML = '<i>' + k + '</i><span class="nzs-jm-subs__stars" aria-label="' + n + ' out of 5">' + starsHtml(Number(n)) + '</span>';
        wrap.appendChild(s); return '';
      });
      el.querySelector('.jdgm-rev__content').appendChild(wrap);
    }

    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    // NZS-JMDATA-0911: no server-rendered scaffold (Judge.me emptied judgeme.widget) -> build the
    // summary header + histogram + empty list from the API response, same jdgm-* classes as the CSS.
    function buildScaffold(res) {
      var mount = root.querySelector('#judgeme_product_reviews, .jdgm-review-widget') || root;
      var avg = esc(res.average_rating || '0'), n = res.number_of_reviews | 0;
      var h = '<div class="jdgm-rev-widg" data-average-rating="' + avg + '" data-number-of-reviews="' + n + '"><div class="jdgm-rev-widg__header"><div class="jdgm-rev-widg__summary">' +
        '<div class="jdgm-rev-widg__summary-stars" role="img" aria-label="Average rating is ' + avg + ' stars">' + starsHtml(Math.round(parseFloat(avg) || 0)) + '</div>' +
        '<div class="jdgm-rev-widg__summary-average">' + avg + ' out of 5</div>' +
        '<div class="jdgm-rev-widg__summary-text">' + esc(res.review_summary_text || ('Based on ' + n + ' review' + (n === 1 ? '' : 's'))) + '</div></div><div class="jdgm-histogram">';
      (res.histogram || []).forEach(function (x) {
        h += '<div class="jdgm-histogram__row" data-rating="' + (x.rating | 0) + '" role="button" tabindex="0" aria-pressed="false" aria-label="' + (x.percentage | 0) + '% (' + (x.frequency | 0) + ') reviews with ' + (x.rating | 0) + ' star rating">' +
          '<div class="jdgm-histogram__star">' + starsHtml(x.rating | 0) + '</div><div class="jdgm-histogram__bar"><div class="jdgm-histogram__bar-content" style="width:' + (x.percentage | 0) + '%"></div></div><div class="jdgm-histogram__frequency">' + (x.frequency | 0) + '</div></div>';
      });
      h += '<div class="jdgm-histogram__row jdgm-histogram__clear-filter" data-rating="null" tabindex="0"></div></div></div><div class="jdgm-rev-widg__body"><div class="jdgm-rev-widg__reviews"></div></div></div>';
      mount.innerHTML = h;
    }

    function cardFor(r) {
      var el = document.createElement('div');
      el.className = 'jdgm-rev';
      el.setAttribute('data-review-id', r.uuid || '');
      el.innerHTML =
        '<div class="jdgm-rev__header">' +
          '<span class="jdgm-rev__author-wrapper"><span class="jdgm-rev__author"></span></span>' +
          '<time class="jdgm-rev__timestamp"></time>' +
          '<span class="jdgm-rev__rating" data-score="' + (r.rating | 0) + '" role="img" aria-label="' + (r.rating | 0) + ' star review">' + starsHtml(r.rating | 0) + '</span>' +
          '<span class="jdgm-rev__buyer-badge-wrapper">' + (r.verified_buyer ? '<span class="jdgm-rev__buyer-badge">Verified buyer</span>' : '') + '</span>' +
        '</div>' +
        '<div class="jdgm-rev__content"><b class="jdgm-rev__title"></b><div class="jdgm-rev__body"></div></div>';
      el.querySelector('.jdgm-rev__author').textContent = r.reviewer_name || 'Anonymous';
      var t = el.querySelector('.jdgm-rev__timestamp');
      t.textContent = fmtDate(r.created_at);
      if (r.created_at) t.setAttribute('datetime', r.created_at);
      var ti = el.querySelector('.jdgm-rev__title');
      if (r.title) ti.textContent = r.title; else ti.parentNode.removeChild(ti);
      el.querySelector('.jdgm-rev__body').innerHTML = r.body_html || '';
      extractSubs(el);
      if (r.reply_content) {
        var rp = document.createElement('div');
        rp.className = 'jdgm-rev__reply nzs-jm-reply';
        rp.textContent = r.reply_content;
        el.appendChild(rp);
      }
      return el;
    }

    function pagerBtn(label, page, aria, current) {
      var a = document.createElement('a');
      a.className = 'jdgm-paginate__page' + (current ? ' jdgm-curt' : '');
      a.setAttribute('role', 'button');
      a.setAttribute('tabindex', '0');
      a.setAttribute('aria-label', aria);
      if (current) a.setAttribute('aria-current', 'page');
      a.textContent = label;
      if (!current) {
        var act = function () {
          go(page);
          var h = root.querySelector('.jdgm-rev-widg__header');
          if (h && h.scrollIntoView) h.scrollIntoView({ behavior: 'smooth', block: 'start' });
        };
        a.addEventListener('click', act);
        a.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); act(); } });
      }
      return a;
    }

    function buildPager(pg) {
      state.totalPages = pg.total_pages || 1;
      state.page = pg.current_page || 1;
      var wrap = root.querySelector('.jdgm-paginate');
      if (!wrap) {
        wrap = document.createElement('div');
        wrap.className = 'jdgm-paginate';
        (widgEl() || root).appendChild(wrap);
      }
      wrap.innerHTML = '';
      var total = state.totalPages, cur = state.page;
      if (total <= 1) return;
      if (cur > 1) wrap.appendChild(pagerBtn('‹', cur - 1, 'Previous page', false));
      var pages = [], i;
      for (i = 1; i <= total; i++) {
        if (i === 1 || i === total || Math.abs(i - cur) <= 1) pages.push(i);
      }
      var last = 0;
      for (i = 0; i < pages.length; i++) {
        if (pages[i] - last > 1) {
          var dots = document.createElement('span');
          dots.className = 'nzs-jm-dots';
          dots.textContent = '…';
          wrap.appendChild(dots);
        }
        wrap.appendChild(pagerBtn(String(pages[i]), pages[i], 'Page ' + pages[i], pages[i] === cur));
        last = pages[i];
      }
      if (cur < total) wrap.appendChild(pagerBtn('›', cur + 1, 'Next page', false));
    }

    function setHistState() {
      var rows = root.querySelectorAll('.jdgm-histogram__row');
      for (var i = 0; i < rows.length; i++) {
        var r = rows[i].getAttribute('data-rating');
        var on = state.filter && r === state.filter;
        rows[i].classList.toggle('jdgm-histogram__row--selected', !!on);
        rows[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      }
    }

    function go(page, quiet) {
      if (state.busy) return;
      state.busy = true;
      var l = listEl();
      if (!quiet && l) skeletons(l, PER_PAGE);
      var mount = root.querySelector('#judgeme_product_reviews, .jdgm-review-widget');
      var p = shopParams();
      p.per_page = PER_PAGE;
      p.page = page;
      p.product_id = mount ? mount.getAttribute('data-id') : '';
      if (state.filter) p.filter_rating = state.filter;
      var qs = [];
      for (var k in p) if (p[k] !== undefined && p[k] !== null && p[k] !== '') qs.push(k + '=' + encodeURIComponent(p[k]));
      fetch(API + '?' + qs.join('&'))
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (!res || !res.reviews) throw new Error('bad response');
          if (!listEl()) buildScaffold(res); // NZS-JMDATA-0911
          var l2 = listEl();
          if (!l2) throw new Error('no list');
          clearSkeletons(l2);
          var old = l2.querySelectorAll('.jdgm-rev');
          for (var i = 0; i < old.length; i++) old[i].parentNode.removeChild(old[i]);
          var frag = document.createDocumentFragment();
          for (var j = 0; j < res.reviews.length; j++) frag.appendChild(cardFor(res.reviews[j]));
          l2.appendChild(frag);
          buildPager(res.pagination || { total_pages: state.totalPages, current_page: page, per_page: PER_PAGE });
          extractSourceBadges(root);
          state.busy = false;
        })
        .catch(function () {
          var l2 = listEl();
          if (l2) clearSkeletons(l2);
          state.busy = false;
        });
    }

    var enhanced = false;
    // NZS-JM-ATTRS-0924 (Blake): average the popup's extra ratings ("Flavour 5/5 · Effectiveness 4/5 · Value 5/5",
    // appended to the review body by NZS-RVF-0905) into the overview card, Sprint Fit style. Shows ONLY the
    // attributes with at least MIN ratings; nothing renders for products without them. Reviews arrive newest
    // first and the line only exists on reviews posted since Sep 2026, so we stop at the first page without one.
    var ATTRS = [['Flavour', 'Flavour'], ['Effectiveness', 'Effectiveness'], ['Value', 'Value for money']], MIN = 3;
    function attrsPaint(agg) {
      var head = root.querySelector('.jdgm-rev-widg__header');
      if (!head || head.querySelector('.nzs-jm-attrs')) return;
      var cols = '';
      ATTRS.forEach(function (a) {
        var x = agg[a[0]];
        if (!x || x.n < MIN) return;
        var avg = (x.sum / x.n).toFixed(1);
        cols += '<div class="nzs-jm-attrs__col"><span class="nzs-jm-attrs__k">' + a[1] + '</span>' +
          '<span class="nzs-jm-attrs__v" aria-label="' + avg + ' out of 5">' + avg + '<small>/5</small></span>' +
          '<span class="nzs-jm-attrs__n">From ' + x.n + ' rating' + (x.n === 1 ? '' : 's') + '</span></div>';
      });
      if (!cols) return;
      var box = document.createElement('div');
      box.className = 'nzs-jm-attrs';
      box.innerHTML = '<p class="nzs-jm-attrs__h">How customers rate it</p><div class="nzs-jm-attrs__row">' + cols + '</div>';
      head.appendChild(box);
    }
    function loadAttrs() {
      var mount = root.querySelector('#judgeme_product_reviews, .jdgm-review-widget');
      var pid = mount ? mount.getAttribute('data-id') : '';
      if (!pid) return;
      var key = 'nzsJmAttrs:' + pid, cached = null;
      try { cached = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) {}
      if (cached && Date.now() - cached.t < 216e5) { attrsPaint(cached.agg); return; }
      var agg = {};
      var step = function (page) {
        var p = shopParams(), qs = [];
        p.per_page = 25; p.page = page; p.product_id = pid;
        for (var k in p) if (p[k] !== undefined && p[k] !== null && p[k] !== '') qs.push(k + '=' + encodeURIComponent(p[k]));
        fetch(API + '?' + qs.join('&')).then(function (r) { return r.json(); }).then(function (res) {
          var revs = (res && res.reviews) || [], hit = 0;
          revs.forEach(function (r) {
            var t = String(r.body_html || '').replace(/<[^>]+>/g, ' ');
            var seen = false;
            t.replace(/(Flavour|Effectiveness|Value) ([1-5])\/5/g, function (_, k, n) {
              var a = agg[k] || (agg[k] = { sum: 0, n: 0 }); a.sum += Number(n); a.n++; seen = true; return '';
            });
            if (seen) hit++;
          });
          if (hit && revs.length === 25 && page < 4) return step(page + 1);
          try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), agg: agg })); } catch (e) {}
          attrsPaint(agg);
        }).catch(function () {});
      };
      step(1);
    }

    function enhance() {
      if (enhanced) return;
      enhanced = true;
      extractSourceBadges(root);
      var w = widgEl();
      var n = w && listEl() ? parseInt(w.getAttribute('data-number-of-reviews') || '0', 10) : -1; // NZS-JMDATA-0911: -1 = no SSR scaffold, fetch + build from the API
      if (n >= 0) buildPager({ total_pages: Math.max(1, Math.ceil(n / PER_PAGE)), current_page: 1, per_page: PER_PAGE });
      // Star-filter: histogram rows toggle a rating filter.
      var onHist = function (e) {
        var row = e.target.closest ? e.target.closest('.jdgm-histogram__row') : null;
        if (!row || row.classList.contains('jdgm-histogram__clear-filter')) return;
        var rating = row.getAttribute('data-rating');
        if (!rating || rating === 'null') return;
        state.filter = state.filter === rating ? null : rating;
        setHistState();
        go(1);
      };
      root.addEventListener('click', onHist);
      root.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          var row = e.target.closest ? e.target.closest('.jdgm-histogram__row') : null;
          if (row) { e.preventDefault(); onHist(e); }
        }
      });
      // Quietly upgrade the SSR first page (5 cards, old per-page vintage) to 12.
      if (n !== 0) go(1, true);
      if (n !== 0) loadAttrs(); /* NZS-JM-ATTRS-0924 */
    }

    // Defer work until the section approaches the viewport; IO delivery can starve
    // in occluded/backgrounded windows, so a timer failsafe backs it up (enhance is
    // idempotent and cheap — one badge pass + one page-1 fetch).
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) { io.disconnect(); enhance(); return; }
        }
      }, { rootMargin: '600px 0px' });
      io.observe(root);
      setTimeout(enhance, 5000);
    } else {
      enhance();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#' + ROOT_ID)) init();
  });
})();